import _extends from '@babel/runtime/helpers/esm/extends';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React from 'react';
import styled, { css } from '@xstyled/styled-components';
import { th } from '@xstyled/system';
import { system, filterFieldComponent } from '@trybeapp/ui.system';
import { HtmlDiv, HtmlSpan } from '@trybeapp/ui.elements';
import { Label, StyledLabel } from '@trybeapp/ui.label';
import { Hint } from '@trybeapp/ui.hint';
import { Box } from '@trybeapp/ui.box';
import 'prop-types';
import { getVariant } from '@trybeapp/ui.utilities';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _excluded = ["iconPlacement", "size"],
  _excluded2 = ["helperText", "checked", "label", "labelFor", "labelInfo", "children", "touched", "error", "component", "required", "type", "warning", "onChange", "onClick", "componentProps", "connected"];
var IconWrapper = /*#__PURE__*/styled(HtmlDiv)(function (_ref) {
  var iconPlacement = _ref.iconPlacement,
    size = _ref.size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: ", ";\n    right: ", ";\n    bottom: 0;\n    display: flex;\n    width: ", ";\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n    transition: medium;\n    transition-timing-function: primary;\n    ", ";\n  "])), iconPlacement === 'left' ? 0 : 'auto', iconPlacement === 'right' ? 0 : 'auto', size ? th("fields.sizes." + size + ".height")(rest) : null, system);
});
var FieldWrapper = /*#__PURE__*/styled(filterFieldComponent(HtmlDiv))(function (_ref2) {
  var _ref2$checked = _ref2.checked,
    checked = _ref2$checked === void 0 ? false : _ref2$checked;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    ", " {\n      ", "\n    }\n  "])), StyledLabel, checked && th('fields.checkablelabel.checked'));
});
var ContentWrapper = /*#__PURE__*/styled(HtmlDiv)(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
var TextMuted = /*#__PURE__*/styled(HtmlSpan)(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
var TYPES = {
  Checkbox: 'checkbox',
  Radio: 'radio',
  Input: 'text',
  RadioTab: 'radio',
  Select: 'text',
  Toggle: 'checkbox'
};
var getBaseType = function getBaseType(type) {
  return TYPES[type] || type;
};
var Field = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var helperText = _ref3.helperText,
    checked = _ref3.checked,
    label = _ref3.label,
    labelFor = _ref3.labelFor,
    labelInfo = _ref3.labelInfo,
    children = _ref3.children,
    touched = _ref3.touched,
    error = _ref3.error,
    Component = _ref3.component,
    _ref3$required = _ref3.required,
    required = _ref3$required === void 0 ? false : _ref3$required,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? 'text' : _ref3$type,
    warning = _ref3.warning,
    onChange = _ref3.onChange,
    onClick = _ref3.onClick,
    componentProps = _ref3.componentProps,
    connected = _ref3.connected,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  var baseType = getBaseType(type || Component.displayName);
  var isCheckbox = baseType === 'checkbox';
  var isRadio = baseType === 'radio';
  var isCheckable = isRadio || isCheckbox;
  var variant = getVariant({
    connected: connected,
    touched: touched,
    warning: warning,
    error: error
  });
  var Children = children && React.cloneElement(children, {
    variant: variant
  });
  var hintText = variant ? error || warning : helperText;
  var inputRef = ref || React.createRef();
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick && onClick(e);
    if (isCheckbox) {
      e.target.checked = !e.target.checked;
    }
    if (isCheckbox) {
      onChange && onChange(e);
    }
  };
  var InputComponent = /*#__PURE__*/React.createElement(Component, _extends({
    type: type,
    variant: variant,
    touched: touched,
    required: required,
    checked: checked,
    onClick: handleClick,
    onChange: onChange,
    ref: inputRef
  }, componentProps, rest));
  return /*#__PURE__*/React.createElement(FieldWrapper, _extends({
    variant: variant,
    checked: checked
  }, rest), label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: labelFor,
    required: required,
    checkableField: isCheckable
  }, isCheckable && InputComponent, /*#__PURE__*/React.createElement(Box, null, label), labelInfo && /*#__PURE__*/React.createElement(TextMuted, null, labelInfo)), !label && isCheckable && InputComponent, /*#__PURE__*/React.createElement(ContentWrapper, null, Children, !isCheckable && InputComponent, hintText && /*#__PURE__*/React.createElement(Hint, {
    variant: variant
  }, hintText)));
});
Field.displayName = 'Field';

export { Field, IconWrapper };
